// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class DiagnoseDetailDto {
    @AutoMap() diagnose: string;
    @AutoMap() midOfficeDiagnoseTypeId: string;
    @AutoMap() icdDiagnoseId: string;
    @AutoMap() icdCode: string;
    @AutoMap() diagnosis: string;
    @AutoMap() medicalInformation: string;
    @AutoMap() medicalHistory: string;
    @AutoMap() nameOfGeneralPractioner: string;
    @AutoMap() cityOfGeneralPractitioner: string;
    @AutoMap() nameSpecialist: string;
    @AutoMap() hospitalinNL: string;
    @AutoMap() phoneNumber: string;
    @AutoMap() hasPermission: boolean;
    @AutoMap() treatmentDoctor: string;
    @AutoMap() function: string;
    @AutoMap() hospital: string;
    @AutoMap() mediacalComments: string;
    @AutoMap() hasMedicalReport: boolean;
    @AutoMap() hasFitFlyDocument: boolean;
    @AutoMap() canSendDocuments: boolean;
    @AutoMap() extraInformationComments: string;
}